import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import properties from '../../../modules/ajio-util/properties';

const cx = classNames.bind(styles);
export const VideoShimmer = ({ isFloatingWidget, displayBottomGradient, isModal, isStory = false }) => {
  let containerClass = '';
  if(isStory){
    containerClass = 'video-shimmer-story';
  }else if(isModal){
    containerClass = 'video-shimmer-modal';
  }else{
    containerClass = 'video-shimmer';
  }
  return (
    <div className={cx(containerClass)}>
      <div
        className={cx('loading-icon')}
        style={{
          width: isModal ? '64px' : isFloatingWidget ? '28px' : '39px',
          height: isModal ? '64px' : isFloatingWidget ? '28px' : '39px'
        }}
      >
        <img
          className={cx('imageIcon')}
          src={`${properties.getProperty('imageBaseUrl')}/static/img/video_buffer.svg`}
          alt="Buffer icon"
          aria-label='Loading'
        />
      </div>
      {!isModal && displayBottomGradient && <div className={cx('bottom-gradient-box')} />}
    </div>
  );
};
